import { db } from "../firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

export async function loadProductAnalytics(days = 30) {
  const now = new Date();

  // Load collections
  const [productsSnap, analyticsSnap, activitySnap] = await Promise.all([
    getDocs(collection(db, "products")),
    getDocs(collection(db, "analyticsProducts")),
    getDocs(collection(db, "analyticsActivity")),
  ]);

  const products = productsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  const analytics = analyticsSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  const activity = activitySnap.docs.map((d) => ({ id: d.id, ...d.data() }));

  // Filter activity by date range
  const filteredActivity = activity.filter((a) => {
    const ts = a.timestamp?.seconds
      ? new Date(a.timestamp.seconds * 1000)
      : null;
    if (!ts) return false;

    const diff = (now - ts) / (1000 * 60 * 60 * 24);
    return diff <= days - 1;
  });

  // Build per-product stats
  const rangeStats = {};
  filteredActivity.forEach((a) => {
    if (!a.productId) return;
    if (!rangeStats[a.productId]) {
      rangeStats[a.productId] = { views: 0, clicks: 0 };
    }
    if (a.type === "view") rangeStats[a.productId].views++;
    if (a.type === "click") rangeStats[a.productId].clicks++;
  });

  // Merge into products
  const merged = products.map((p) => {
    const allTime = analytics.find((a) => a.id === p.id) || {};
    // const range = rangeStats[p.id] || { views: 0, clicks: 0 };

    return {
      ...p,
      views: allTime.views,
      likes: allTime.likes || 0,
      viewsAllTime: allTime.views || 0,
      clicksAllTime: allTime.amazonClicks || 0,
    };
  });

  return merged;
}
